"use client";

import { EmployerSideMenuNav } from "@/app/employers/[officeId]/(use-shared-layout)/EmployerSideMenuNav";
import { HorizontalLine } from "@/components/ui/HorizontalLine";
import { getEmployersZendeskUrl } from "@/constants/zendesk-urls/employers-zendesk-urls";
import { cn } from "@/lib/utils";
import { employersZendeskSsoLink } from "@/server/models/zendesk/zendesk-sso-link";
import { pagesPath } from "@/utils/pages-path";
import TextLogo from "@public/mykenpo-text-logo-employer.svg";
import Link from "next/link";

const TopElements = ({ params }: { params: { officeId: string } }) => {
  return (
    <div>
      <div className="ml-6 flex h-20 items-center">
        <Link href={pagesPath.employers._officeId(params.officeId).$url().path}>
          <TextLogo />
        </Link>
      </div>
      <EmployerSideMenuNav params={params} />
    </div>
  );
};

const BottomElements = ({
  officeName,
  officeCode,
  insurerNumber,
}: {
  officeName: string;
  officeCode: string;
  insurerNumber: string;
}) => {
  return (
    <div className="flex flex-col gap-6 p-6 text-sm">
      <div>
        <p className="mb-3 font-bold">{officeName}</p>
        <div className="flex flex-col">
          <p>保険者番号：{insurerNumber}</p>
          <p>事業所記号：{officeCode}</p>
        </div>
        <Link
          href={employersZendeskSsoLink(getEmployersZendeskUrl("法人設定"))}
          prefetch={false}
          target="_blank"
          className="mt-4 inline-flex gap-2 hover:underline"
        >
          法人設定
        </Link>
      </div>
      <HorizontalLine />
      <div className="flex flex-col gap-2">
        <Link
          href="https://docsend.com/view/rntcuqc3u68qvfss"
          target="_blank"
          className="font-bold hover:underline"
        >
          保険料額表
        </Link>
        <Link
          href={employersZendeskSsoLink(getEmployersZendeskUrl("利用規約"))}
          prefetch={false}
          target="_blank"
          className="font-bold hover:underline"
        >
          利用規約
        </Link>
        <Link
          href={employersZendeskSsoLink(
            getEmployersZendeskUrl("個人情報保護方針"),
          )}
          prefetch={false}
          target="_blank"
          className="font-bold hover:underline"
        >
          個人情報保護方針
        </Link>
        <Link
          href={employersZendeskSsoLink(getEmployersZendeskUrl("公告"))}
          prefetch={false}
          target="_blank"
          className="font-bold hover:underline"
        >
          公告
        </Link>
      </div>
      <div className="whitespace-pre-wrap">
        {"©︎VCスタートアップ健保/\n©︎株式会社SalusTech"}
      </div>
    </div>
  );
};

export const sideMenuId = "side-menu";

export const EmployersSideMenu = ({
  officeName,
  officeCode,
  insurerNumber,
  sideMenuOpened,
  params,
}: {
  officeName: string;
  officeCode: string;
  insurerNumber: string;
  sideMenuOpened: boolean;
  params: { officeId: string };
}) => {
  return (
    <div
      id={sideMenuId}
      data-opened={sideMenuOpened}
      className={cn(
        "z-50 flex max-w-[232px] min-w-[232px] flex-col justify-between overflow-y-scroll transition-transform",
        "bg-primary-0.5",
        // ヘッダ分を抜いた高さ
        "fixed top-[80px] h-[calc(100%-80px)]",
        // 画面外に隠しておいて表示するときにずらす
        "left-[-232px] data-[opened=true]:translate-x-[232px]",
        // 一定幅以上の場合は常にサイドメニューを表示
        "lg:sticky lg:top-0 lg:h-screen",
      )}
    >
      <TopElements params={params} />
      <BottomElements
        officeName={officeName}
        officeCode={officeCode}
        insurerNumber={insurerNumber}
      />
    </div>
  );
};
